import { Extension } from '@tiptap/core';
import precommentHighlightPlugin from './precommentHighlightPlugin';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    highlight: {
      /**
       * Set a highlight mark
       */
      setPreCommentHighlight: (attributes?: any) => ReturnType;
      /**
       * Unset a highlight mark
       */
      removePreCommentHighlightSelection: () => ReturnType;
    };
  }
}

const PreCommentHighlight = Extension.create({
  name: 'precommenthighlight',

  addProseMirrorPlugins() {
    return [precommentHighlightPlugin];
  },

  addCommands() {
    return {
      setPreCommentHighlight:
        (attributes) =>
        ({ tr, dispatch }) => {
          tr = tr.setMeta('preCommentHighlight', { ...attributes, action: 'add' });

          if (dispatch) {
            dispatch(tr);
          }
          return true;
        },
      removePreCommentHighlightSelection:
        () =>
        ({ tr, dispatch }) => {
          tr = tr.setMeta('preCommentHighlight', {
            action: 'remove',
          });

          if (dispatch) {
            dispatch(tr);
          }
          return true;
        },
    };
  },
});

export default PreCommentHighlight;
